import { Alpha3Code } from 'i18n-iso-countries'

import { PrecheckType } from '@percent/education-hosted-form/api/hostedFormPrecheck/hostedFormPrecheck.types'

export type GetPartnerConfigParams = {
  programId?: string
}

export type PartnerConfigResponse = {
  data: PartnerConfiguration
}

export type PartnerConfiguration = {
  id: string
  hostedConfigurationId: string
  redirectUrl: string
  language: string
  status: ValidationInviteStatus
  partner: {
    id: string
    name: string
    logo: string
    createdAt: string
    deletedAt?: string
    currencyCode: string
    legalName?: string
    allowedActivitySubTags: Array<string>
  }
  configuration: {
    id: string
    primaryColor: string
    terms: string
    logo: string
    partnerFields: FormField[]
    avCheckAvailable?: boolean
    prechecks?: PrecheckType[]
    externalAgentVerificationEnabled?: boolean
    // True when Goodstack sends the outcome email, not the partner.
    shouldSendOutcomeEmail?: boolean
    education: EducationConfig | null
  }
}

export type EduStage = 'pre-primary' | 'primary' | 'secondary' | 'higher'

export type EduHostedFormType = 'student' | 'staff'

export type EducationConfig = {
  eduHostedFormType: EduHostedFormType
  // Education stages the form accepts in org search. Empty → no stage restriction.
  allowedStages: EduStage[]
  // Countries the form is offered in. Empty → all countries.
  supportedCountries: Alpha3Code[]
  // The partner's own privacy policy. null when they have not given us one.
  partnerPrivacyPolicyUrl: string | null
}

export enum ValidationInviteStatus {
  OPEN = 'open',
  EXPIRED = 'expired',
  COMPLETE = 'complete'
}

export enum FieldType {
  ShortText = 'short_text',
  MultipleChoice = 'multiple_choice',
  Number = 'number',
  Select = 'select'
}

export type FormField = {
  title: string
  id: string
  placeholder?: string
  type: FieldType
  validation?: {
    maxLength?: number
    required?: boolean
  }
  options?: {
    key: string
    value: string
  }[]
}
